import React, { useCallback } from "react";
import { message, notification } from "antd";
import TierBadge from "../../v2/components/TierBadge";
import { tierOption } from "../../v2/tierMeta";
import { LandTourDetail } from "../../../../interfaces/land-tour.interface";

const ICONS = "/iceholidays-assets/images/icons";

interface Props {
  landTour: LandTourDetail;
}

// handleShareLink mirrors pages/gd/ShowPage.tsx's handleShareLink (copy-to-clipboard,
// stripping ref/keyword) - no dedicated share component exists in the codebase to reuse.
export default function GroundTourHeader({ landTour }: Props) {
  const handleShareLink = useCallback(() => {
    const url = new URL(window.location.href);
    url.searchParams.delete("ref");
    url.searchParams.delete("keyword");

    if (!navigator.clipboard) {
      notification.error({ message: "Unable to copy link. Please copy the URL from your browser." });
      return;
    }

    navigator.clipboard.writeText(url.toString()).then(() => {
      message.success("Tour link is ready to be shared to your friends and family");
    }).catch(() => {
      notification.error({ message: "Unable to copy link. Please copy the URL from your browser." });
    });
  }, []);

  return (
    <header className="ground-tour-show-v2__header">
      <div className="ground-tour-show-v2__header-chips">
        {landTour.isNew && <span className="ground-tour-show-v2__new-badge">New</span>}
        <span className="ground-tour-show-v2__code-chip">
          <img src={`${ICONS}/icon-tour-code.png`} alt="" aria-hidden="true" />
          {landTour.code}
        </span>
      </div>

      <div className="ground-tour-show-v2__title-row">
        <h1 className="ground-tour-show-v2__title">{landTour.title}</h1>

        <div className="ground-tour-show-v2__title-actions">
          {tierOption(landTour.brand) && (
            // A span, not a button - there's no defined destination for this tag to
            // navigate to (the chevron is decorative, matching the Figma), and a
            // clickable-looking control with no handler is worse than none at all.
            <span className="ground-tour-show-v2__tier-tag">
              <TierBadge tier={landTour.brand} />
              {/* Masked so it recolors via currentColor to match .tier-tag's own color. */}
              <span
                className="ground-tour-show-v2__tier-tag-chevron"
                style={{
                  WebkitMaskImage: `url(${ICONS}/icon-tier-chevron.svg)`,
                  maskImage: `url(${ICONS}/icon-tier-chevron.svg)`,
                }}
                aria-hidden="true"
              />
            </span>
          )}

          <button type="button" className="ground-tour-show-v2__share" onClick={handleShareLink}>
            <span className="ground-tour-show-v2__share-icon">
              <img src={`${ICONS}/icon-share.png`} alt="" aria-hidden="true" />
            </span>
            Share
          </button>
        </div>
      </div>
    </header>
  );
}
